import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-password\">\n<g id=\"icon-password_lock-on\">\n<g id=\"icon-password_Union\">\n<path d=\"M9 15V16.5H15V15H9Z\" fill=\"#737373\" />\n<path d=\"M6.75 7.48627V8.99998H4.5C4.08579 8.99998 3.75 9.33576 3.75 9.74998V20.25C3.75 20.6642 4.08579 21 4.5 21H19.5C19.9142 21 20.25 20.6642 20.25 20.25V9.74998C20.25 9.33576 19.9142 8.99998 19.5 8.99998H17.25V7.48627C17.25 4.58677 14.8995 2.23627 12 2.23627C9.10051 2.23627 6.75 4.58677 6.75 7.48627ZM15.75 8.99998H8.25V7.48627C8.25 5.4152 9.92893 3.73627 12 3.73627C14.0711 3.73627 15.75 5.4152 15.75 7.48627V8.99998ZM5.25 10.5H18.75V19.5H5.25V10.5Z\" fill=\"#737373\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/password.svg
// module id = QjmH
// module chunks = 102